import addError from '../../../../utils/error.jsx';
import confirm from '../../../../utils/confirm.jsx';

export function request(price) {
    return confirm('Are you sure you want to delete this price', {
        type: 'LADDERS_DELETE_PRICE_REQUEST',
        price
    });
}

export function error(errors) {
    addError(errors);

    return {
        type: 'LADDERS_DELETE_PRICE_ERROR',
        errors
    };
}

export function finish({prices}) {
    return (dispatch) => {
        dispatch({
            type: 'LADDERS_DELETE_PRICE_FINISH',
            prices
        });

        dispatch({
            type: 'LADDERS_GET_LIST_REQUEST'
        });
    };
}
